import styled from "styled-components";
import { color, media, maxWidth } from "../../styles/theme";

export const StyledContainer = styled("div")<{
  $border?: boolean;
  $padding?: string;
  $narrow?: boolean;
}>`
  position: relative;
  width: 100%;
  max-width: ${({ $narrow }) => ($narrow ? maxWidth.narrow : maxWidth.page)};
  margin-right: auto;
  margin-left: auto;
  padding: ${({ $padding }) => $padding || "0 2.5rem"};
  border-bottom: ${({ $border }) => ($border ? `1px solid ${color.ash}` : "none")};

  ${media.lg} {
    padding: ${({ $padding }) => $padding || "0 2rem"};
  }

  ${media.md} {
    padding: ${({ $padding }) => $padding || "0 1.25rem"};
  }
`;
